<template>
  <div class="__C_Checkbox" :class="{ inline: inline }">
    <q-checkbox v-model="currentValue" :val="val" :disable="disable" :dense="dense" :size="size">
      <slot>{{ label }}</slot>
    </q-checkbox>
  </div>
</template>

<script>
export default {
  name: 'CCheckBox',
  props: {
    value: {
      type: [String, Boolean, Array, Object],
      default: false,
    },
    val: {
      type: [String, Object],
    },

    // Style
    label: {
      type: String,
    },
    inline: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },

    // State
    disable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentValue: {
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.__C_Checkbox /deep/ {
  z-index: 10;
  .q-checkbox__inner {
    /*padding: 0;*/
    /*<!--margin-left: -21px;-->*/
  }
}

.__C_Checkbox {
  &.inline {
    display: inline-block;
  }
}
</style>
